/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { CSATFeature } from "./CSATFeature";
import type { CSATRequestedPayloadSideEffectType } from "./CSATRequestedPayloadSideEffectType";

export interface CSATRequestedPayload {
  side_effect_type: CSATRequestedPayloadSideEffectType;
  survey_key: CSATFeature;
  conversation_id: string;
  encounter_id?: string | null;
  requested_at: string;
}
